import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const NotFound = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledError>
            <h1>
                {t('Page.NotFound.Title', { defaultValue: '404 Not found' })}
            </h1>
            <p>
                {t('Page.NotFound.Description', {
                    defaultValue: 'This page does not exist',
                })}
            </p>
        </StyledError>
    );
});

const StyledError = styled.div`
    z-index: 115;
    width: 100%;
    height: 100%;
    text-align: center;

    h1 {
        transform: translateY(650%);
    }

    p {
        transform: translateY(1300%);
    }
`;
